<ng-container *transloco="let t">
  <img
    class="logo"
    src="/assets/images/lifespeak_brand_logo.svg"
    alt="LifeSpeak"
    data-test-id="redirect.logo"
  />

  @if (showMoreInfo()) {
    <app-login-more-info
      [clients]="clients"
      [email]="email"
      [deepLinkPath]="deepLinkPath"
    ></app-login-more-info>
  } @else {

  <div class="pt-12">
    <h1 class="heading-t5" data-test-id="redirect.title">{{ t('redirect.title') }}</h1>
    <h2 class="text-b2 font-medium font-PoppinsMedium mt-1" data-test-id="redirect.subtitle">{{ t('redirect.subtitle') }}</h2>
  </div>

  <form (submit)="onSubmit($event)" class="mt-4" data-test-id="redirect.form">
    <div class="pt-5">
      @if (emailControl.touched && emailControl.hasError('required')) {
        <div class="error-message ls-text-b3 font-medium" data-test-id="redirect.email-error">{{ t('redirect.emailRequired') }}</div>
      }
      <div class="pb-3">
        <label for="email" class="ml-entLbl">{{ t('redirect.emailLabel') }}</label>
      </div>
      <div>
        <input
          id="email"
          type="text"
          [formControl]="emailControl"
          [placeholder]="t('redirect.emailPlaceholder')"
          class="max-w-full"
          [class.invalid]="emailControl.touched && emailControl.invalid"
          data-test-id="redirect.email-input"
          [attr.aria-invalid]="emailControl.touched && emailControl.invalid"
          autocomplete="off"
        />
      </div>
    </div>
    <div class="pt-5 pb-5">
      <ls-button
        btnType="submit"
        btnVariant="primary"
        size="lg"
        [upcase]="false"
        [label]="submitting() ? t('redirect.submitting') : t('redirect.submit')"
        [disabled]="submitting()"
        data-test-id="redirect.submit-button"
      ></ls-button>
    </div>
    <div>
      <a (click)="onShowInviteCode()" class="register-link" data-test-id="redirect.invite-link">{{ t('redirect.inviteMsg') }}</a>
    </div>
  </form>
  }
</ng-container>
